<template>
    <n-config-provider :theme="darkTheme" :theme-overrides="themeOverrides">
        <router-view/>
    </n-config-provider>
</template>

<script setup lang="ts">
import {darkTheme, NConfigProvider} from 'naive-ui';

// MasterAllArts brand tweaks — match site's brand-500 (#d67d2e orange)
const themeOverrides = {
    common: {
        primaryColor: '#d67d2e',
        primaryColorHover: '#e08a3e',
        primaryColorPressed: '#b86a22',
        primaryColorSuppl: '#d67d2e',
    },
};
</script>

<style>
html {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #0a0a0a;
}

body {
    width: 100%;
    height: 100%;
    margin: 0;
    background: #0a0a0a;
    color: #e5e5e5;
}

#app {
    width: 100%;
    height: 100%;
    font-size: 14px;
    background: #0a0a0a;
}

/* Scrollbars on dark */
::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

::-webkit-scrollbar-track {
    background: transparent;
}

::-webkit-scrollbar-corner {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, .12);
    border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, .22);
}

/* Override hard-coded light-theme colors in Search.vue */
.description {
    color: #a3a3a3 !important;
}
.description a {
    color: #d67d2e !important;
}
.description a:hover {
    color: #e08a3e !important;
}
.search-condition label {
    color: #a3a3a3 !important;
}
.result {
    border-color: rgba(255, 255, 255, .1) !important;
    background: rgba(255, 255, 255, .02);
}
</style>
